import { render } from "./CoursesListPage.vue?vue&type=template&id=ce98384a&scoped=true&ts=true"
import script from "./CoursesListPage.vue?vue&type=script&lang=ts"
export * from "./CoursesListPage.vue?vue&type=script&lang=ts"

import "./CoursesListPage.vue?vue&type=style&index=0&id=ce98384a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce98384a"]])

export default __exports__